import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { useParams } from 'react-router';

import { useCampaignsByIds } from '@/api/campaign';
import { Page, PageDateRangeFilter, PageFilterProvider } from '@/components/page';
import { ReturnToLink } from '@/components/ReturnToLink';
import { exampleAIQuestions } from '@/constants/exampleAIQuestions';
import { CAMPAIGN_GROUP_MAX_LIMIT } from '@/constants/numbers';
import { ROUTES } from '@/router';

import CampaignDetailActions from './CampaignDetailActions';
import CampaignDetailContent from './CampaignDetailContent';
import CampaignDetailErrorOrChildren from './CampaignDetailErrorOrChildren';
import CampaignTagList from './CampaignTagList';

const CampaignDetail = () => {
  const { campaigns: campaignIdString } = useParams();

  const campaignIds = campaignIdString?.split(',');
  const { campaigns, isLoading } = useCampaignsByIds(campaignIds);
  const isGrouped = !!(campaignIds && campaignIds?.length > 1);

  const campaignName = isGrouped ? t`Grouped (${campaignIds?.length})` : campaigns?.[0].name;
  const pageTitle = campaignName;

  return (
    <Page
      title={t`Campaign`}
      pageName={pageTitle}
      exampleAIQuestions={exampleAIQuestions('campaign')}
    >
      <div className="flex w-full flex-col gap-6">
        <div className="flex items-start justify-between gap-8">
          <ReturnToLink
            route={ROUTES.campaigns.path}
            routeName={<Trans>Campaign Overview</Trans>}
          />
          <CampaignTagList campaigns={campaigns} />
        </div>
        <PageFilterProvider>
          <CampaignDetailErrorOrChildren
            campaignIds={campaignIds}
            maxLimit={CAMPAIGN_GROUP_MAX_LIMIT}
          >
            <div className="flex justify-between">
              <PageDateRangeFilter />
              <CampaignDetailActions campaignIds={campaignIds!} isLoading={isLoading} />
            </div>
            <CampaignDetailContent
              campaignName={campaignName}
              campaignIds={campaignIds}
              isLoading={isLoading}
            />
          </CampaignDetailErrorOrChildren>
        </PageFilterProvider>
      </div>
    </Page>
  );
};

export default CampaignDetail;
